
import { Button } from "@/components/ui/button";
import Navigation from "@/components/Navigation";

interface ErrorStateProps {
  error: string;
  debugInfo: string;
  onRetry: () => void;
}

const ErrorState = ({ error, debugInfo, onRetry }: ErrorStateProps) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
      <Navigation />
      <div className="py-8 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center">
            <div className="text-red-600 mb-4">
              <h2 className="text-xl font-semibold mb-2">Unable to Load Investments</h2>
              <p className="mb-4">{error}</p>
            </div>
            
            {debugInfo && (
              <div className="mb-6 p-4 bg-yellow-100 rounded-lg">
                <h3 className="font-semibold text-yellow-800 mb-2">Diagnostic Information:</h3>
                <p className="text-sm text-yellow-700">{debugInfo}</p>
              </div>
            )}
            
            <Button onClick={onRetry} className="mr-2">
              Try Again
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorState;
